/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Si estamos programando una aplicación con Vue y necesitamos iterar en un array para renderizar una serie de elementos, Vue no da la función `}<inlineCode parentName="p">{`v-for`}</inlineCode>{` para iterar sobre el `}<inlineCode parentName="p">{`array`}</inlineCode>{` y `}<inlineCode parentName="p">{`v-bind:key`}</inlineCode>{` para asignarle un identificador único a cada elemento de la lista.`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-html"
      }}><code parentName="pre" {...{
          "className": "language-html"
        }}><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`ul`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
  `}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`li`}</span>{` `}<span parentName="span" {...{
              "className": "token attr-name"
            }}>{`v-for`}</span><span parentName="span" {...{
              "className": "token attr-value"
            }}><span parentName="span" {...{
                "className": "token punctuation attr-equals"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span>{`cat in cats`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span></span>{` `}<span parentName="span" {...{
              "className": "token attr-name"
            }}><span parentName="span" {...{
                "className": "token namespace"
              }}>{`v-bind:`}</span>{`key`}</span><span parentName="span" {...{
              "className": "token attr-value"
            }}><span parentName="span" {...{
                "className": "token punctuation attr-equals"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span>{`cat.id`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
    {cat.name}
  `}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`li`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
`}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`ul`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
`}</code></pre></div>
    <p><strong parentName="p">{`Este concepto en nuestra aplicación luciría así:`}</strong></p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-html"
      }}><code parentName="pre" {...{
          "className": "language-html"
        }}>{`// ...Pokedex.vue
`}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`ul`}</span>{` `}<span parentName="span" {...{
              "className": "token attr-name"
            }}>{`class`}</span><span parentName="span" {...{
              "className": "token attr-value"
            }}><span parentName="span" {...{
                "className": "token punctuation attr-equals"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span>{`pokemon-stats`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span></span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
  `}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`Stat`}</span>{`
    `}<span parentName="span" {...{
              "className": "token attr-name"
            }}><span parentName="span" {...{
                "className": "token namespace"
              }}>{`v-bind:`}</span>{`item`}</span><span parentName="span" {...{
              "className": "token attr-value"
            }}><span parentName="span" {...{
                "className": "token punctuation attr-equals"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span>{`item`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span></span>{`
    `}<span parentName="span" {...{
              "className": "token attr-name"
            }}>{`v-for`}</span><span parentName="span" {...{
              "className": "token attr-value"
            }}><span parentName="span" {...{
                "className": "token punctuation attr-equals"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span>{`item in pokemon.stats`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span></span>{`
    `}<span parentName="span" {...{
              "className": "token attr-name"
            }}><span parentName="span" {...{
                "className": "token namespace"
              }}>{`v-bind:`}</span>{`key`}</span><span parentName="span" {...{
              "className": "token attr-value"
            }}><span parentName="span" {...{
                "className": "token punctuation attr-equals"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span>{`item.stat.name`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`"`}</span></span>{`
  `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`/>`}</span></span>{`
`}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`ul`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
// ...Pokedex.vue
`}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span>{`script`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span><span parentName="code" {...{
            "className": "token script"
          }}><span parentName="span" {...{
              "className": "token language-javascript"
            }}>{`
`}<span parentName="span" {...{
                "className": "token keyword module"
              }}>{`import`}</span>{` `}<span parentName="span" {...{
                "className": "token imports"
              }}><span parentName="span" {...{
                  "className": "token maybe-class-name"
                }}>{`Stat`}</span></span>{` `}<span parentName="span" {...{
                "className": "token keyword module"
              }}>{`from`}</span>{` `}<span parentName="span" {...{
                "className": "token string"
              }}>{`'./Stat.vue'`}</span>{`
`}<span parentName="span" {...{
                "className": "token keyword module"
              }}>{`export`}</span>{` `}<span parentName="span" {...{
                "className": "token keyword module"
              }}>{`default`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`
  `}<span parentName="span" {...{
                "className": "token literal-property property"
              }}>{`name`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`:`}</span>{` `}<span parentName="span" {...{
                "className": "token string"
              }}>{`'PokedexScreen'`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`,`}</span>{`
  `}<span parentName="span" {...{
                "className": "token literal-property property"
              }}>{`components`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`:`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`
    `}<span parentName="span" {...{
                "className": "token maybe-class-name"
              }}>{`Stat`}</span>{`
  `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`,`}</span>{`
`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`<`}</span>{`script`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`>`}</span>{`
`}<span parentName="span" {...{
                "className": "token comment"
              }}>{`// ...Pokedex.vue`}</span>{`


`}<span parentName="span" {...{
                "className": "token comment"
              }}>{`// Dentro de Stat.vue`}</span>{`
`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`<`}</span>{`template`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`>`}</span>{`
  `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`<`}</span>{`li `}<span parentName="span" {...{
                "className": "token keyword"
              }}>{`class`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token string"
              }}>{`"pokemon-stat"`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`>`}</span>{`
    `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`<`}</span>{`span `}<span parentName="span" {...{
                "className": "token keyword"
              }}>{`class`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`=`}</span><span parentName="span" {...{
                "className": "token string"
              }}>{`"stat-name"`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`>`}</span>{`
      `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`<`}</span>{`b`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`>`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`item`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token property-access"
              }}>{`stat`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token property-access"
              }}>{`name`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`:`}</span>{` `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`/`}</span>{`b`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`>`}</span>{`
    `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`/`}</span>{`span`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`>`}</span>{`
    `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`<`}</span>{`span`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`>`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`item`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`.`}</span><span parentName="span" {...{
                "className": "token property-access"
              }}>{`base_stat`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`/`}</span>{`span`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`>`}</span>{`
  `}<span parentName="span" {...{
                "className": "token operator"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`/`}</span>{`li`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`>`}</span>{`
`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`/`}</span>{`template`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`>`}</span>{`

`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`<`}</span>{`script`}<span parentName="span" {...{
                "className": "token operator"
              }}>{`>`}</span>{`
`}<span parentName="span" {...{
                "className": "token keyword module"
              }}>{`export`}</span>{` `}<span parentName="span" {...{
                "className": "token keyword module"
              }}>{`default`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`
  `}<span parentName="span" {...{
                "className": "token literal-property property"
              }}>{`name`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`:`}</span>{` `}<span parentName="span" {...{
                "className": "token string"
              }}>{`'Stat'`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`,`}</span>{`
  `}<span parentName="span" {...{
                "className": "token literal-property property"
              }}>{`props`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`:`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`
    `}<span parentName="span" {...{
                "className": "token comment"
              }}>{`// PropTypes on Vue`}</span>{`
    `}<span parentName="span" {...{
                "className": "token literal-property property"
              }}>{`item`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`:`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span>{`
      `}<span parentName="span" {...{
                "className": "token literal-property property"
              }}>{`type`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`:`}</span>{` `}<span parentName="span" {...{
                "className": "token known-class-name class-name"
              }}>{`Object`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`,`}</span>{`
      `}<span parentName="span" {...{
                "className": "token function-variable function"
              }}>{`default`}</span><span parentName="span" {...{
                "className": "token operator"
              }}>{`:`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`(`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`)`}</span>{` `}<span parentName="span" {...{
                "className": "token arrow operator"
              }}>{`=>`}</span>{` `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`{`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span>{`
    `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span>{`
  `}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span>{`
`}<span parentName="span" {...{
                "className": "token punctuation"
              }}>{`}`}</span>{`
`}</span></span><span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`</`}</span>{`script`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`>`}</span></span>{`
`}</code></pre></div>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;